import { EstimateList } from "./EstimateList";
import { EstimateShow } from "./EstimateShow";

export default {
  list: EstimateList,
  show: EstimateShow,
};
